(() => {
  const KEY = 'model-view-enabled';
  const MQ = window.matchMedia('(max-width: 749px)');
  const preloaded = new WeakSet();

  const items = () => document.querySelectorAll('.product-grid__item');
  const isOn = () => sessionStorage.getItem(KEY) === 'true';

  /* ---------- toggle placement ---------- */

  const mountMobile = (wrapper) => {
    const sticky = document.querySelector('sticky-facets-toggle');
    if (!sticky) return false;

    if (wrapper.previousElementSibling !== sticky) sticky.after(wrapper);

    const sortRow = document.querySelector('.mv-sort-row');
    if (sortRow) sortRow.classList.remove('mv-sort-row');

    wrapper.classList.add('is-mounted', 'mv-mobile');
    wrapper.classList.remove('mv-desktop');
    return true;
  };

  const mountDesktop = (wrapper) => {
    const hosts = [...document.querySelectorAll('sorting-filter-component')];
    const host = hosts.find((h) => h.offsetParent !== null) || hosts[0];
    if (!host) return false;

    if (wrapper.nextElementSibling !== host) host.before(wrapper);

    const parent = host.parentElement;
    if (parent) parent.classList.add('mv-sort-row');

    wrapper.classList.add('is-mounted', 'mv-desktop');
    wrapper.classList.remove('mv-mobile');
    return true;
  };

  const mount = () => {
    const wrapper = document.querySelector('.model-view-toggle-wrapper');
    if (!wrapper) return false;
    return MQ.matches ? mountMobile(wrapper) : mountDesktop(wrapper);
  };

  const mountWhenReady = () => {
    if (mount()) return;
    let tries = 0;
    const tick = () => {
      if (mount() || ++tries > 240) return;
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  /* ---------- overlay ---------- */

  const getHost = (item) => item.querySelector('.product-grid__card') || item;

  const getMedia = (item) =>
    item.querySelector('.product-media-container') ||
    item.querySelector('.product-media') ||
    item.querySelector('.card-gallery');

  const sizeOverlay = (overlay, host, media) => {
    if (!media || !host) return;
    const mediaRect = media.getBoundingClientRect();
    const hostRect = host.getBoundingClientRect();
    if (!mediaRect.height) return;
    overlay.style.top = `${mediaRect.top - hostRect.top}px`;
    overlay.style.left = `${mediaRect.left - hostRect.left}px`;
    overlay.style.width = `${mediaRect.width}px`;
    overlay.style.height = `${mediaRect.height}px`;
  };

  const getOverlay = (item) => {
    const existing = item.querySelector('.mv-overlay');
    if (existing) return existing;

    const src = item.dataset.modelImage;
    if (!src) return null;

    const host = getHost(item);
    if (!host) return null;

    host.classList.add('mv-card');

    const overlay = document.createElement('img');
    overlay.className = 'mv-overlay';
    overlay.alt = '';
    overlay.decoding = 'async';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.src = src;

    sizeOverlay(overlay, host, getMedia(item));

    const badges = host.querySelector('.product-badges');
    if (badges) {
      badges.after(overlay);
    } else {
      host.appendChild(overlay);
    }
    return overlay;
  };

  const resizeAll = () => {
    items().forEach((item) => {
      const overlay = item.querySelector('.mv-overlay');
      if (overlay) sizeOverlay(overlay, getHost(item), getMedia(item));
    });
  };

  /* ---------- apply ---------- */

  const preload = (item) => {
    if (preloaded.has(item)) return;
    preloaded.add(item);
    getOverlay(item);
  };
  const preloadAll = () => items().forEach(preload);

  const swap = (item, on) => {
    const overlay = getOverlay(item);
    if (!overlay) return;
    overlay.classList.toggle('is-visible', on);
  };

  const apply = (on) => {
    items().forEach((item) => swap(item, on));
    document.body.classList.toggle('model-view-active', on);
  };

  const sync = () => {
    const toggle = document.getElementById('ModelViewToggle');
    if (toggle) toggle.setAttribute('aria-checked', String(isOn()));
  };

  /* ---------- events ---------- */

  document.addEventListener(
    'click',
    (e) => {
      const toggle = e.target.closest && e.target.closest('#ModelViewToggle');
      if (!toggle) return;
      e.preventDefault();
      e.stopPropagation();

      const next = !isOn();
      sessionStorage.setItem(KEY, next);
      sync();
      resizeAll();
      apply(next);
    },
    true
  );

  let scheduled = false;
  const refresh = () => {
    mount();
    sync();
    preloadAll();
    apply(isOn());
  };

  const scheduleRefresh = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      refresh();
    });
  };

  let resizeTimer;
  const onResize = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      mount();
      resizeAll();
    }, 150);
  };

  /* ---------- init ---------- */

  const init = () => {
    mountWhenReady();
    refresh();

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(preloadAll);
    } else {
      setTimeout(preloadAll, 200);
    }

    new MutationObserver(scheduleRefresh).observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.addEventListener('resize', onResize, { passive: true });

    const onMQ = () => {
      mount();
      resizeAll();
    };
    if (typeof MQ.addEventListener === 'function') {
      MQ.addEventListener('change', onMQ);
    } else {
      MQ.addListener(onMQ);
    }

    document.addEventListener('shopify:section:load', refresh);
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init, { once: true })
    : init();
})();